import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import UserRow from './UserRow.js'
import './users.css'
import { colors } from '../../app/variables.js'
import _ from 'lodash'
import getLabel from '../../utilities/label.js'
import SessionRow from '../Sessions/SessionRow.js'
import TitleBar from '../TitleBar/index.js'
import initializeHelperText from '../../utilities/helperText.js'

export default class MyProfile extends Component {

  constructor(props) {
    super(props)
    var user = this.getUser(window.currentUser.user_id)
    this.getMessageAlert = this.getMessageAlert.bind(this)
    const backButton = '<i class=\'fa fa-arrow-left\'></i> ' + getLabel('back_button')
    this.state = {
      user: user,
      previewSrc: null,
      backButton: backButton
    }
    this.props.setActiveTab('homepage')
    window.trackPage('ProfileMyScreen')
  }

  componentDidMount(){
    initializeHelperText()
  }

  getUser(id) {
    return _.find(this.props.users.event_users, {user_id: parseInt(id, 10)})
  }

  getMessageAlert() {
    // only show message alert if block messages not true
    // if(!this.state.user.block_messages){
    let filterFunction = (message) => !message.has_been_read && message.recipient_user_id === this.props.currentUser.user_id
    let unreadMessages = this.props.messages.messages.filter(filterFunction)
    return unreadMessages.length ? unreadMessages.length : null
    // }
  }

  getBizCardInfo(attr, labelKey) {
    if(attr == null) {
      return getLabel(labelKey) + ' ' + getLabel('not_provided')
    } else {
      return attr
    }
  }

  getSpeakerSessions(){
    const sessions = []
    _.each(this.props.sessions.sessions, (session) => {
      let speakerUsersIds = _.map(session.event_session_speakers, function(speaker) {return speaker.user_id})
      if(speakerUsersIds.indexOf(this.state.user.user_id) > -1){
        sessions.push(
          <div className="speaker-session" key={session.id}>
            <div className="display-date">{session.formatted_display_date}</div>
            <SessionRow session={session} postResource={ this.props.postResource } flashMessage={ this.props.flashMessage } />
          </div>
        )
      }
    })
    return sessions
  }

  getPrivateMessagesButton(){
    // if(!this.state.user.block_messages){
    return <span className={'fa-stack fa-3x has-badge ' + (this.getMessageAlert() ? 'red' : '')} data-count={this.getMessageAlert()}><Link to='/messages'><button className='send-message'><i className='fa fa-envelope-o'></i> Private Messages</button></Link></span>
    // } else {
    // return <span className=''><button disabled className='button-disabled'><i className='fa fa-envelope-o'></i> Private Messages<i className='fa fa-question helper-text' data-content="Your messages have been disabled." rel='popover' data-placement='bottom' data-trigger='hover'></i></button></span>
    // }
  }

  render() {
    return this.state.user ? (
      <div className='user-profile'>
        <TitleBar
          title={ getLabel('my_profile') }
          leftButtonLabel={ this.state.backButton }
          leftButtonAction={ () => window.history.back() } />
        <img className="rounded-circle" src={this.state.previewSrc} alt='' />
        <UserRow user={this.state.user} skipLink={true} skipEllipsis={true} />
        <Link
          to='/edit_photo'
          className='blue-header'>Edit Photo</Link>
        <div className='user-actions'>
          <Link to='/edit_profile'><button className='edit-profile'><i className="fa fa-wrench"></i> Edit Profile</button></Link>
          { this.getPrivateMessagesButton() }
          <Link className='logout' to='' onClick={ this.props.logout } >
            <button style={{ color: colors.evantaBlue }} >
              <i className='fa fa-sign-out'></i> { getLabel('logout') }
            </button>
          </Link>

          <span className='blue-header'><h2>{ getLabel('my_biz_card') }</h2></span>
          <div className="form-fine-print">
            { getLabel('biz_card_notice') }
          </div>
          <div className="my-biz-card">
            <h3 dangerouslySetInnerHTML={{__html: this.state.user.first_name + ' ' + this.state.user.last_name}} ></h3>
            <p>{this.getBizCardInfo(this.state.user.email)}</p>
            <p>{this.getBizCardInfo(this.state.user.address, 'address')}</p>
            <p>{this.getBizCardInfo(this.state.user.city, 'city')}</p>
            <p>{this.getBizCardInfo(this.state.user.state, 'state')}</p>
            <p>{this.getBizCardInfo(this.state.user.postal_code, 'postal_code')}</p>
            <p>{this.getBizCardInfo(this.state.user.phone, 'phone')}</p>
          </div>
          <br></br>
        </div>
        <div className='user-bio'>
          <span className='blue-header'><h3>Dietary Restrictions</h3></span>
          <p>{ this.state.user.dietary_restrictions }</p>
        </div>
        <div className="form-fine-print">
          <p>This field will not be shared with business card exchange or be viewable by other users. This information is used by event staff only.</p>
        </div>
        <div>
          <span className='blue-header'><h3>Bio</h3></span>
          <p dangerouslySetInnerHTML={{__html: this.state.user.bio}} ></p>
        </div>
        { this.state.user.is_speaker &&
            <div>
            	<span className='blue-header'><h3>{ getLabel('session_speaker_at') }</h3></span>
            	{this.getSpeakerSessions()}
            </div>
        }
        <pre className="debug-json">{JSON.stringify(this.state.user, false, 2)}</pre>
      </div>
    ) : <div><a onClick={() => window.history.back()}>back</a><h1>User Not found</h1></div>
  }
}
